import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { injectIntl } from 'react-intl';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { BaseComponent } from '../../../components/BaseComponent';
import { resetCompanyFilter, changeCompanySortOrder, updateCompanyFilter, changeCompanyFilter } from '../actions';
import { selectCompanyFilter } from '../selectors';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { setVehiclesSort } from '../../Vehicles/actions';
import ButtonComponent from '../../../containers/App/Components/Button/Button';

const FiltersWrapper = styled.div`
  display: flex;
  gap: 10px;
  justify-content: start;
  align-items: center;
  padding: 12px 0;
  width: 100%;
  flex-wrap: wrap;
`;

const FilterLabel = styled.div`
  background-color: var(--color-new-primary);
  color: var(--color-new-white);

  font-size: 12px;
  padding: 4px 8px;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: nowrap;
  gap: 5px;
`;

const DeleteFilterButton = styled.div`
  cursor: pointer;
  font-size: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const ClearButton = styled.span`
  font-weight: bold;
  font-size: 12px;
  color: #df4074;
  text-decoration: underline;
  cursor: pointer;
`;

const altFilters = ['sell_without_license_plate', 'dont_fix_damages'];

/* eslint-disable react/prefer-stateless-function */
class FiltersCloudComp extends BaseComponent {
  constructor(props) {
    super(props);
  }

  deleteFilter = filterName => {
    if (['fix_damages', 'dont_fix_damages']?.includes(filterName)) {
      this.props.reset('fix_damages');
      this.props.reset('dont_fix_damages');
    } else if (['sell_with_license_plate', 'sell_without_license_plate']?.includes(filterName)) {
      this.props.reset('sell_with_license_plate');
      this.props.reset('sell_without_license_plate');
    } else {
      this.props.reset(filterName);
    }
  };

  clearAllFilters = () => {
    this.props.clearAll();
  };

  render() {
    const filtersList = this.props.filter?.properties?.filter(f => !altFilters?.includes(f.key));
    const searchString = this.props.filter?.searchString ?? '';
    const filterName = name => this.lblStr(`company.filter.${name}`);
    const filterValue = (value, type, label, name) => {
      if (name === 'regplate' || name === 'task_label') {
        return label[0];
      }

      if (value.id) {
        return value?.company_type !== 'individual' ? value?.name ?? '' : `${value?.name ?? ''} ${value?.surname ?? ''}`;
      }

      if (name === 'searchString') {
        return value;
      }

      switch (type) {
        case 'multiple':
          return label?.length ? label.join(', ') : value.join(', ');
        default:
          return label && label[0]
            ? label[0]
            : value[0] == '1'
            ? `${filterName('yes')}`
            : value[0] == '0'
            ? `${filterName('no')}`
            : value[0];
      }
    };
    const sortTypeLabel = this.lblStr(`vehicle.sort.${this.props.filter?.sortType}`);
    return (
      <FiltersWrapper>
        {searchString && (
          <FilterLabel key={'searchString'}>
            {`${filterName('searchString')}: ${filterValue(searchString, 'single', 'searchString', 'searchString')}`}
            <DeleteFilterButton
              onClick={() => {
                this.props.setSearchString();
              }}
            >
              <FontAwesomeIcon icon={faTimes} />
            </DeleteFilterButton>
          </FilterLabel>
        )}
        {this.props.filter?.sortType && (
          <FilterLabel key={'vehicle_sort'}>
            {`${this.lblStr('vehicle.sort.by')}: ${sortTypeLabel}, ${this.props.filter?.order}`}
            <DeleteFilterButton onClick={this.props.resetSort}>
              <FontAwesomeIcon icon={faTimes} />
            </DeleteFilterButton>
          </FilterLabel>
        )}
        {filtersList?.map(filter => (
          <FilterLabel key={filter?.key}>
            {`${filterName(filter?.key)}: ${filterValue(filter?.value, filter?.type, filter?.label, filter?.key)}`}
            <DeleteFilterButton onClick={() => this.deleteFilter(filter?.key)}>
              <FontAwesomeIcon icon={faTimes} />
            </DeleteFilterButton>
          </FilterLabel>
        ))}
        {!!filtersList.length && (
          <ButtonComponent style={'ButtonSoftDelete'} onClick={this.clearAllFilters}>
            <FontAwesomeIcon icon={faTimes} />
          </ButtonComponent>
        )}
      </FiltersWrapper>
    );
  }
}

FiltersCloudComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    filter: selectCompanyFilter(),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    reset(filterName) {
      dispatch(
        updateCompanyFilter(null, {
          reset: filterName,
        }),
      );
    },
    resetSort() {
      dispatch(changeCompanySortOrder(null, null));
    },
    clearAll: () => {
      dispatch(resetCompanyFilter());
    },
    setSearchString(string) {
      dispatch(changeCompanyFilter('searchString', ''));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const FiltersCloud = compose(withConnect, withRouter, injectIntl)(FiltersCloudComp);
